import React from "react";
import { Card } from "react-bootstrap";
import {
  FiUser,
  FiClock,
  FiCalendar,
  FiFileText,
  FiUserCheck,
  FiSliders,
  FiDownload
} from "react-icons/fi";

const data = [
  {
    title: "Applied",
    value: "1,848",
    label: "Overall Progress",
    percent: 36.3,
    color: "orange",
    icon: <FiUser />,
  },
  {
    title: "Shortlisted",
    value: "2,384",
    label: "Conversion rate",
    percent: 37.4,
    color: "teal",
    icon: <FiClock />,
  },
  {
    title: "Interviewed",
    value: "892",
    label: "Conversion rate",
    percent: 36.3,
    color: "dark",
    icon: <FiCalendar />,
  },
  {
    title: "Offered",
    value: "324",
    label: "Conversion rate",
    percent: 26.5,
    color: "blue",
    icon: <FiFileText />,
  },
  {
    title: "Hired",
    value: "64",
    label: "Conversion rate",
    percent: 41.2,
    color: "green",
    icon: <FiUserCheck />,
  },
];

export default function StagePerformance() {
  return (
    <Card className="stage-card">
      <Card.Body>

        {/* HEADER */}
        <div className="header">
          <h5>Stage Performance</h5>

          <div className="header-actions">
            <div className="icon-btn">
              <FiSliders />
            </div>
            <span className="days">
              <FiDownload /> Last 30 Days
            </span>
          </div>
        </div>

        {/* CARDS */}
        <div className="stage-grid">
          {data.map((item, i) => (
            <div className="stage-item" key={i}>

              {/* TOP */}
              <div className="top">
                <p>{item.title}</p>

                <div className={`icon ${item.color}`}>
                  {item.icon}
                </div>
              </div>

              {/* VALUE */}
              <h2>{item.value}</h2>

              {/* LABEL */}
              <div className="progress-label">
                <span>{item.label}</span>
                <span>{item.percent}%</span>
              </div>

              {/* PROGRESS */}
              <div className="progress-bar">
                <div
                  className={`progress-fill ${item.color}`}
                  style={{ width: `${item.percent}%` }}
                ></div>
              </div>

            </div>
          ))}
        </div>

      </Card.Body>

      {/* ================= STYLES ================= */}
      <style>{`

        .stage-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }

        /* HEADER */
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }

        .header-actions {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .icon-btn {
          width: 40px;
          height: 40px;
          background: #f3f4f6;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .days {
          font-size: 14px;
          color: #374151;
        }

        /* GRID */
        .stage-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 15px;
        }

        .stage-item {
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 15px;
        }

        .top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        .top p {
          margin: 0;
          font-weight: 500;
        }

        /* ICON */
        .icon {
          width: 45px;
          height: 45px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .orange { background: linear-gradient(135deg,#ff6a00,#ff8c42); }
        .teal { background: #0f4c5c; }
        .dark { background: #1f2937; }
        .blue { background: #2f80ed; }
        .green { background: #22c55e; }

        /* VALUE */
        h2 {
          font-weight: 700;
          margin-bottom: 10px;
        }

        /* LABEL */
        .progress-label {
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          color: #6b7280;
        }

        /* PROGRESS */
        .progress-bar {
          height: 6px;
          background: #e5e7eb;
          border-radius: 10px;
          margin-top: 5px;
        }

        .progress-fill {
          height: 100%;
          border-radius: 10px;
        }

        .progress-fill.orange { background: #ff6a00; }
        .progress-fill.teal { background: #0f4c5c; }
        .progress-fill.dark { background: #111827; }
        .progress-fill.blue { background: #2f80ed; }
        .progress-fill.green { background: #22c55e; }

        /* ================= RESPONSIVE ================= */

        /* Tablet + Mobile → 2 per row */
        @media (max-width: 1024px) {
          .stage-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        /* Small mobile spacing improvement */
        @media (max-width: 576px) {
          .stage-grid {
            gap: 10px;
          }

          .stage-item {
            padding: 12px;
          }
        }

      `}</style>
    </Card>
  );
}